import React, { useState, useEffect, useRef } from 'react';
import './Enrollmentv2.css';
import Body from '../../components/Body/Body';
import Formbox from '../../components/Formbox/Formbox';
import { PersonalInformation, SuccessfulEnrollment, Confirmation, checkToken } from './Enrollmentv2_helper';
import Terms from '../../components/Terms/Terms';
import ShareGridient from '../../components/ShareGridient/ShareGridient';
import GoogleSignIn from '../../components/GoogleSignin/GoogleSignin';
import AppleSignin from '../../components/AppleSignin/AppleSignin';
import {
    GoogleReCaptchaProvider,
    useGoogleReCaptcha
} from 'react-google-recaptcha-v3';
import { useLocation } from 'react-router-dom';



function decodeJwtPayload(token) {
    try {
        const base64Payload = token.split('.')[1];
        if (!base64Payload) return null;

        let payloadJson;
        if (typeof Buffer !== 'undefined') {
            payloadJson = Buffer.from(base64Payload, 'base64').toString('utf8');
        } else if (atob) {
            payloadJson = atob(base64Payload);
        } else {
            return null;
        }
        return JSON.parse(payloadJson);
    } catch (e) {
        return null;
    }
}



const defaultPayload = {
    first_name: "",
    last_name: "",
    email: "",
    phone_number: "",
    password: ""
};


const Enrollmentv2 = () => {
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const user = searchParams.get('user');
    const [payload, setPayload] = useState(defaultPayload); // Initialize payload with the default payload
    const [activeStep, setActiveStep] = useState([]);
    const [lastStep, setLastStep] = useState(1); // Create a new state to track the previous step
    const [next, setNext] = useState('Next');
    const [AgreedtoTerms, setAgreedtoTerms] = useState(false);
    const AgreedtoTermsREF = useRef(null);
    const { executeRecaptcha } = useGoogleReCaptcha();
    const [enrollmentSubmitted, setEnrollmentSubmitted] = useState(null);
    const [provider, setProvider] = useState(false)
    const [pendingStep, setPendingStep] = useState(null); // <-- Add this line
    const handleReCaptchaVerify = (async () => {
        if (!executeRecaptcha) {
            return;
        }

        const token = await executeRecaptcha('submit_form');

        if (!token) {
            alert('Recaptcha verification failed. Please try again.');
        }
        const pay = payload;
        pay.token = token;
        setPayload(pay);
        // Do whatever you want with the token
    });

    const submitEnrollmentapi = async (payload) => {
        try {
            const BACKEND = process.env.REACT_APP_BACKEND_BASE; // Use environment variable for API endpoint 
            // const BACKEND = 'http://localhost:8000'; // Replace with your actual API endpoint
            const response = await fetch(`${BACKEND}/v2/user/enroll`, { // Use environment variable for API endpoint
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(payload)
            });
            if (response.status === 401) {
                window.location.href = '/';
            }
            else if (response.status === 409) {
                alert("Enrollment is Duplicated Please Use Your Original Email")
            }
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }
            const data = await response.json();
            // Assuming the API response contains a "redirect_link"
            setEnrollmentSubmitted(data);
        } catch (error) {
            console.error("Enrollment submission failed:", error);
            // Optionally, display an error message to the user.
        }
    }

    const steps = [
        { id: 1, text: "Personal Information", show: () => <PersonalInformation /> },
        { id: 2, text: "Review", show: () => <Confirmation data={payload}></Confirmation> } // Pass the payload to the Confirmation component,
    ];

    const handleStepClick = (stepId) => {
        setActiveStep((prevSteps) => [...new Set([...prevSteps, stepId])]);
    };

    const collectFormData = (formSelector = '.form-register') => {
        const formData = new FormData(document.querySelector(formSelector));
        const formPayload = {};

        formData.forEach((value, key) => {
            formPayload[key] = value;
        });

        return formPayload;
    };

    const handleAnchorClick = (stepId) => {
        const collectedData = collectFormData(); // No need to pass the selector
        // Validate required fields before setting payload

        // Merge new form data with the existing payload
        if (steps.length === stepId) {
            setNext('Sign Up');
        }

        setPayload(prevPayload => {
            const newPayload = {
                ...prevPayload,
                first_name: collectedData['first-name'] || prevPayload.first_name,
                last_name: collectedData['last-name'] || prevPayload.last_name,
                email: collectedData['your_email'] || prevPayload.email,
                phone_number: collectedData['phone'] || prevPayload.phone_number,
                password: collectedData['password'] || prevPayload.password
            };
            return newPayload;
        });
        if (
            !(payload['first_name'] || collectedData['first-name']) ||
            !(payload['last_name'] || collectedData['last-name']) ||
            !(payload['email'] || collectedData['your_email']) ||
            (!(payload['password'] || collectedData['password']) && !(provider))
        ) {
            alert("Please fill out all fields");
            return;
        }
        if (!AgreedtoTerms) {
            alert("Please Agree to Terms to Continue")
            return;
        }
        handleStepClick(stepId);
        setLastStep(stepId); // Update the lastStep state
    };
    useEffect(() => {
        if (AgreedtoTerms && AgreedtoTermsREF.current) {
            AgreedtoTermsREF.current.scrollIntoView({ behavior: 'smooth' });
        }
    }, [AgreedtoTerms]);

    // Dummy Google Signin success handler
    const handleGoogleSuccess = (response) => {
        try {
            const decoded = decodeJwtPayload(response.credential);
            setPayload(prev => ({
                ...prev,
                first_name: decoded.given_name,
                last_name: decoded.family_name,
                email: decoded.email,
                phone_number: "123456789",
                agreed_to_terms: new Date().toISOString()
            }));
            setAgreedtoTerms(true);
            setProvider(true);
            setPendingStep(2); // <-- Set pending step
        } catch (e) {
            console.error("Failed to decode Google credential:", e);
        }
    };

    // Dummy Apple Signin success handler
    const handleAppleSuccess = (response) => {
        console.log("Apple Signin Success:", response);
        if (!response.user) {
            alert(
                "Account already exist"
            )
            return
        }
        setPayload(prev => ({
            ...prev,
            first_name: response.user.name.firstName,
            last_name: response.user.name.lastName,
            email: response.user.email,
            phone_number: "123456789",
            agreed_to_terms: new Date().toISOString()
        }));
        setAgreedtoTerms(true);
        setProvider(true);
        setPendingStep(2); // <-- Set pending step
    }

    useEffect(() => {
        if (user) {
            if (user === "ALREADYSIGNEDUP") {
                alert("Account already exist");
                return;
            }
            handleAppleSuccess({ user: JSON.parse(decodeURIComponent(user)) });
        }
    }, [user]);
    
    useEffect(() => {
        if (
            pendingStep === 2 &&
            AgreedtoTerms &&
            provider &&
            payload.first_name &&
            payload.last_name &&
            payload.email
        ) {
            handleAnchorClick(2);
            setPendingStep(null);
        }
    }, [pendingStep, AgreedtoTerms, provider, payload.first_name, payload.last_name, payload.email]);
    return (
        <div>
            <Body elements={
                <Formbox elements={
                    <>

                        <form className='form-register'>
                            <div className="steps">
                                <ul>
                                    {steps.map(step => (
                                        <li key={step.id}>
                                            <h2>
                                                <a onClick={() => handleAnchorClick(step.id)}>
                                                    <div className='title'>
                                                        <p
                                                            className="step-icon"
                                                            style={{
                                                                backgroundColor: step.id === 1
                                                                    ? '#4fab40' // Always green for step 1
                                                                    : activeStep.includes(step.id)
                                                                        ? '#4fab40'
                                                                        : '#ccc'
                                                            }}
                                                        >
                                                            <span>{`0${step.id}`}</span>
                                                        </p>
                                                        <span className="step-text">{step.text}</span>
                                                    </div>
                                                </a>
                                            </h2>
                                        </li>
                                    ))}
                                </ul>
                            </div>

                            <div className='form-content' style={{ overflow: 'hidden' }}>

                                {
                                    enrollmentSubmitted === null
                                        ? steps.find(step => step.id === lastStep)?.show?.()
                                        : (<SuccessfulEnrollment enrollmentSubmitted={enrollmentSubmitted} />)
                                }
                                {lastStep === 1 && enrollmentSubmitted === null && (
                                    <div>
                                        <ShareGridient></ShareGridient>
                                        <Terms text={'Please Read Terms and Click Agree to Terms to Continue'}></Terms>
                                        <button className='agree-button' style={{
                                            backgroundColor: AgreedtoTerms ? 'green' : 'grey'
                                        }}
                                            type='button' onClick={() => {
                                                setAgreedtoTerms(true)
                                                payload.agreed_to_terms = new Date().toISOString();
                                                setPayload(
                                                    payload
                                                )
                                            }}>
                                            &#10003; I Accept
                                        </button>
                                    </div>
                                )}
                                {AgreedtoTerms && enrollmentSubmitted === null && (
                                    <div className="button-container">
                                        <button
                                            type="button"
                                            ref={AgreedtoTermsREF}
                                            disabled={next === 'Loading...'} // Disable the button while loading
                                            onClick={async () => {
                                                const nextStepId = lastStep === null ? 2 : lastStep + 1;
                                                if (nextStepId <= steps.length) {
                                                    handleAnchorClick(nextStepId);
                                                } else {
                                                    await handleReCaptchaVerify()
                                                    setNext('Loading...'); // Set the button text to "Loading..."
                                                    await submitEnrollmentapi(payload); // Wait for the API call to complete
                                                    setNext('Sign Up');
                                                }
                                            }}
                                        >
                                            {next}
                                        </button>
                                    </div>
                                )}
                                {lastStep === 1 && enrollmentSubmitted === null && (
                                    <div style={{ marginTop: "24px", marginBottom: "24px", display: "flex", flexDirection: "column", gap: "12px" }}>
                                        <GoogleSignIn className="inner" handleSuccess={handleGoogleSuccess} />
                                        <AppleSignin className="inner" onSuccess={handleAppleSuccess} />
                                    </div>
                                )}
                            </div>
                        </form>
                    </>
                }
                ></Formbox>
            }></Body>
        </div>
    );
};

export default Enrollmentv2;
